export default __webpack_public_path__ + "static/media/wall.0570c102.png";